<script lang="ts">
  import { AppState } from '../../etc/stores';

  const {
    primary,
    secondary,
    tertiary,
    quaternary,
    firstStopColor,
    secondStopColor
  } = $AppState.theme.colors.illustration;
</script>

<svg
  width="99"
  height="80"
  viewBox="0 0 99 80"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  {#if !$$props.hideBackground}
    <circle
      cx="55.2002"
      cy="40"
      r="40"
      fill="url(#paint0_linear)"
      fill-opacity="0.4"
    />
  {/if}
  <path
    d="M21.9033 42.3133L48.9857 14.6379C52.1589 11.3952 57.3848 11.4184 60.5291 14.6889L87.0873 42.3133V64.2336H21.9033V42.3133Z"
    fill={primary}
  />
  <rect x="28.7998" y="16.8" width="50.4" height="52" rx="5" fill="white" />
  <g style="mix-blend-mode:multiply">
    <rect
      x="28.7998"
      y="32.8"
      width="50.4"
      height="40"
      fill="url(#paint1_linear)"
    />
  </g>
  <rect
    x="36.6748"
    y="40.425"
    width="32.025"
    height="3.15"
    rx="1.575"
    fill={tertiary}
  />
  <rect
    x="36.6748"
    y="33.0747"
    width="15.75"
    height="3.15"
    rx="1.575"
    fill={tertiary}
  />
  <rect
    x="36.6748"
    y="25.7251"
    width="15.75"
    height="3.15"
    rx="1.575"
    fill={tertiary}
  />
  <rect
    x="36.6748"
    y="47.7749"
    width="32.025"
    height="3.15"
    rx="1.575"
    fill={tertiary}
  />
  <path
    d="M54.2069 61.9259L21.9033 42.313L21.9033 72.886C21.9033 75.4347 23.9694 77.5008 26.5181 77.5008H82.4725C85.0212 77.5008 87.0873 75.4347 87.0873 72.886V42.313L54.2069 61.9259Z"
    fill={secondary}
  />
  <mask
    id="mask0"
    style="mask-type:alpha"
    maskUnits="userSpaceOnUse"
    x="21"
    y="42"
    width="67"
    height="36"
  >
    <path
      d="M54.2069 61.9259L21.9033 42.313L21.9033 72.886C21.9033 75.4347 23.9694 77.5008 26.5181 77.5008H82.4725C85.0212 77.5008 87.0873 75.4347 87.0873 72.886V42.313L54.2069 61.9259Z"
      fill={secondary}
    />
  </mask>
  <g mask="url(#mask0)">
    <path
      d="M42.8819 55.0502L21.9033 77.501H87.0873L66.214 54.7639L54.2069 61.926L42.8819 55.0502Z"
      fill={quaternary}
    />
  </g>
  <path
    d="M9.42589 62.4941C7.44583 57.1493 8.72471 58.4282 3.37988 56.4481C8.72471 54.4681 7.44583 55.7469 9.42589 50.3999C11.4059 55.7447 10.1271 54.4658 15.4719 56.4459C10.1271 58.426 11.4059 57.1471 9.42589 62.4941Z"
    fill={secondary}
  />
  <path
    d="M2.42687 65.2467C1.63208 63.1013 2.14542 63.6146 0 62.8198C2.14542 62.025 1.63208 62.5384 2.42687 60.3921C3.22167 62.5375 2.70832 62.0242 4.85374 62.819C2.70832 63.6138 3.22167 63.1004 2.42687 65.2467Z"
    fill={secondary}
  />
  <path
    d="M82.8466 14.4199C84.8266 9.07507 83.5478 10.3539 88.8926 8.37389C83.5478 6.39384 84.8266 7.67271 82.8466 2.32568C80.8665 7.67051 82.1454 6.39163 76.8006 8.37169C82.1454 10.3517 80.8665 9.07286 82.8466 14.4199Z"
    fill={secondary}
  />
  <path
    d="M94.3436 19.3903C95.1384 17.2449 94.6251 17.7582 96.7705 16.9634C94.6251 16.1686 95.1384 16.6819 94.3436 14.5356C93.5488 16.6811 94.0622 16.1677 91.9168 16.9625C94.0622 17.7573 93.5488 17.244 94.3436 19.3903Z"
    fill={secondary}
  />
  <path
    d="M94.2435 8.13989C95.5764 4.54261 94.7155 5.40334 98.3135 4.07069C94.7155 2.73803 95.5764 3.59877 94.2435 0C92.9106 3.59728 93.7715 2.73655 90.1736 4.0692C93.7715 5.40186 92.9106 4.54112 94.2435 8.13989Z"
    fill={secondary}
  />
  <defs>
    <linearGradient
      id="paint0_linear"
      x1="55.2002"
      y1="0"
      x2="55.2002"
      y2="60.9221"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={firstStopColor} />
      <stop offset="1" stop-color={secondStopColor} />
    </linearGradient>
    <linearGradient
      id="paint1_linear"
      x1="53.9998"
      y1="37.4154"
      x2="53.9998"
      y2="68.4"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.210219" stop-color="white" stop-opacity="0" />
      <stop offset="1" stop-color={primary} stop-opacity="0.977578" />
    </linearGradient>
  </defs>
</svg>
